export default __webpack_public_path__ + "static/media/013-grassland.4fff816f.svg";